import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 130 130",
  "content": "<symbol viewBox=\"0 0 130 130\" xmlns=\"http://www.w3.org/2000/svg\" id=\"user\"><path d=\"M53.172 78.77c-7.42-4.743-12.294-13.492-12.294-23.502C40.878 40.208 51.913 28 66.048 28c13.088 0 24.123 12.208 24.123 27.268 0 10.192-5.054 19.078-12.378 23.758C95.293 83.858 108 98.037 108 111.902c0 17.124-17.204 19.927-40.902 19.927-23.799 0-45.098-2.803-45.098-19.927C22 97.784 35.175 83.34 53.172 78.77z\" /><path d=\"M0 0h130v130H0z\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol